exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.BudoTextarea[data-v-0a34f4b0] {\n    font-size:16px;\n    width:100%;\n    border: 1px solid #dcdfe6;\n    height: 36px;\n    line-height: 30px;\n    padding-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a34f4b0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BudoTextarea.vue
// module id = 576
// module chunks = 75